import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { setNavigationMenuLayout, setSelectedMenuItem } from "@/components/Menu/menuSlice";
import { setSaveItem, setSaveMode } from "@/components/SavePage/saveSlice";
import { createSaveItem } from "@/lib/saved-items";
import { ActionIcon, Button, Group, Title } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { drawingInfo } from "./drawingSlice";

export interface DrawingHeaderProps {
    title: string;
    onClose: () => void;
}
const DrawingHeader: React.FC<DrawingHeaderProps> = ({title, onClose}) => {
    const dispatch = useAppDispatch();
    const currentDrawingInfo = useAppSelector(drawingInfo);

    const onSaveClickHandler = () => {
        if (!currentDrawingInfo) return;
        const { type, shape, color, size, totalArea, totalLength, totalPerimeter, latLon } = currentDrawingInfo;
        const itemDetails = [totalArea, totalLength, totalPerimeter, latLon].filter((detail): detail is string => Boolean(detail));
        dispatch(setSaveMode('new'));
        dispatch(setSaveItem(createSaveItem({ itemType: type, shape, color, size, itemDetails })));
        dispatch(setNavigationMenuLayout('default'));
        dispatch(setSelectedMenuItem('closed'));
    }

    return (
        <Group h="100%" bg="white" justify='center' align='center'>
            <ActionIcon style={{ position: 'absolute', top: 15, left: 10 }} onClick={onClose} variant='transparent' size='md' aria-label='Close Drawing Tool'>
                <IconChevronLeft color='black' />
            </ActionIcon>
            <Title order={4} mb={10} mt={10}>{title}</Title>
            <Button style={{ position: 'absolute', top: 10, right: 10 }} onClick={onSaveClickHandler} variant='transparent' size='md' color="pq-red" aria-label='Save Drawing'>
                Save
            </Button>
        </Group>
    );
}

export default DrawingHeader;
